import RestfulService from "../common/RestfulService";

/**
 * Question + Answer. See also: issb.js
 * 
 * This part of the API is non-standard -- e.g. edits to questions can be made in various ways. Check IssbQuestionController.java and other activity/answer/other code.
 *
 * TODO Standardise more on RESTfulService when practical.
 */
const questionService = new RestfulService("/issb/question");

export default questionService;
